module.exports = __webpack_public_path__ + "img/logo.0d138011.png";